// extracted by mini-css-extract-plugin
export default {"title-with-categories__title":"styles_title-with-categories__title__KB-C1","title-with-categories__content":"styles_title-with-categories__content__7jarb"};